import $ from 'jquery';
import 'intersection-observer';
import rimg from 'rimg-shopify';
import CurrencyConverter from 'shopify-currency-converter';
import ProductItem from '../snippets/ProductItem';
import Select from '../components/Select';
import Menu from '../components/Menu';

export default class StaticSection {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);
    this.el = section.el;
    this.data = section.data;

    this.$clearButton = $('[data-clear-tags]', this.$el);
    this.onFilterChange = this._onFilterChange.bind(this);
    this.onSortByChange = this._onSortByChange.bind(this);
    this._infiniteScrollHandler = this._infiniteScrollHandler.bind(this);

    this.selectWrapperFilter = section.el.querySelector(
      '[data-select-wrapper-filter]',
    );

    this.selectWrapperSortBy = section.el.querySelector(
      '[data-select-wrapper-sortby]',
    );

    if (this.selectWrapperFilter && this.selectWrapperSortBy) {
      this.selectFilter = new Select(
        this.selectWrapperFilter,
        {
          callback: this.onFilterChange,
        },
      );

      this.selectSortBy = new Select(
        this.selectWrapperSortBy,
        {
          callback: this.onSortByChange,
        },
      );
    }

    // Menu system
    this.states = {
      default: {
        buttonsSelector: '[data-collection-menu-buttons-default]',
        buttons: [
          {
            selector: '[data-collection-menu-button-sortby]',
            callback: () => { this.menu.changeState(this.states.sortBy); },
          },
          {
            selector: '[data-collection-menu-button-refine]',
            callback: () => { this.menu.changeState(this.states.refine); },
          },
        ],
      },
      sortBy: {
        slideoutSelector: '[data-collection-slideout-sortby]',
        buttonsSelector: '[data-collection-menu-buttons-sortby]',
        buttons: [
          {
            selector: '[data-collection-menu-slideout-button-dismiss]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-collection-menu-button-cancel]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-collection-menu-button-apply]',
            callback: () => { this._applySortByAndRefine(); },
          },
        ],
        dismiss: () => { this.menu.changeState(this.states.default); },
      },
      refine: {
        slideoutSelector: '[data-collection-slideout-refine]',
        buttonsSelector: '[data-collection-menu-buttons-refine]',
        buttons: [
          {
            selector: '[data-collection-menu-slideout-button-dismiss]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-collection-menu-button-cancel]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-collection-menu-button-apply]',
            callback: () => { this._applySortByAndRefine(); },
          },
        ],
        dismiss: () => { this.menu.changeState(this.states.default); },
      },
    };

    this.$collectionMenuContainer = $('[data-collection-menu-container]', this.$el);
    this.menu = new Menu(this.$collectionMenuContainer, this.states, this.states.default);

    // History
    this.isThemeEditor = window.Shopify && window.Shopify.designMode;
    this.useHistory = !this.isThemeEditor && history.pushState;

    // Filters
    this.$collectionTags = $('[data-collection-tag]', this.$el);
    this.$sortByOptions = $('[data-sortby-option]', this.$el);

    this.selectedCollectionTag = this.useHistory
      ? this.data.current_tags
      : '';

    // Product items
    this.productItems = [];
    const $productItems = $('[data-product-item]', this.$el);

    for (const productItem of $productItems) {
      this.productItems.push(
        new ProductItem($(productItem), this.section.postMessage)
      );
    }

    // Infinite scroll
    if (this.data.pagination_method.indexOf('infinite_scroll') > -1
      && this.data.products_per_page < this.data.total_products
      && window.location.search.indexOf('page') === -1
    ) {
      this.loadMoreTarget = this.el.querySelector('[data-infinite-scroll-target]');
      this.showMoreButton = this.el.querySelector('[data-infinite-scroll-show-more]');
      this.showMoreButton.style.display = 'block';

      // If we're infinite scrolling, we want to hide pagination
      // while still keeping it accessible for screenreaders.
      const pagination = this.el.querySelector('.pagination');
      pagination.style.position = 'absolute';
      pagination.style.left = '-9999px';

      this.currentPage = 1;
      this.fullCollectionLoaded = false;
      this.enableInfiniteScroll = true;

      if (this.data.pagination_method === 'infinite_scroll') {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
              this.scrollTargetVisible = true;
              this._infiniteScroll();
            } else {
              this.scrollTargetVisible = false;
            }
          });
        });

        observer.observe(this.loadMoreTarget);
      }
    }

    this._setSortByQueryParameters();
    this._updateSortByButtons();
    this._bindEvents();

    this.$el[0].addEventListener('rimg-loaded', () => {
      const $collectionGrid = $('[data-collection-grid]', this.$el);

      $collectionGrid.removeClass('collection-grid-uninit');
      this._positionItems();
    });
  }

  _bindEvents() {
    $(window).on('resize.collection', () => this._positionItems());

    // Handles collection tag click event
    this.$collectionTags.on('click.collection-menu', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const $selectedTag = $(event.currentTarget);
      const tag = $selectedTag.data('collection-tag');

      $('[data-collection-tag-selected]').removeAttr('data-collection-tag-selected');
      this.selectedCollectionTag = tag;
      $selectedTag.attr('data-collection-tag-selected', '');
      this.$clearButton.removeClass('hidden');
    });

    this.$clearButton.on('click', (event) => {
      this.selectedCollectionTag = '';
      $('[data-collection-tag-selected]').removeAttr('data-collection-tag-selected');
    });

    this.$sortByOptions.on('click.collection-menu', (event) => {
      const $selectedSortByOption = $(event.currentTarget);

      Shopify.queryParams.sort_by = $selectedSortByOption.val();
      this.$sortByOptions
        .parent()
        .removeClass('collection-sortby-option-selected');
      $selectedSortByOption
        .parent()
        .addClass('collection-sortby-option-selected');
    });

    if (this.enableInfiniteScroll) {
      this.showMoreButton.addEventListener('click', this._infiniteScrollHandler);
    }
  }

  _unbindEvents() {
    $(window).off('resize.collection');
    this.$collectionTags.off('click.collection-menu');
    this.$sortByOptions.off('click.collection-menu');
    if (this.enableInfiniteScroll) {
      this.showMoreButton.removeEventListener('click', this._infiniteScrollHandler);
    }
  }

  _positionItems() {
    const $header = $('[data-collection-header]', this.$el);
    const $gridItems = $('[data-collection-grid-item]', this.$el);
    const headerBottom = $header[0].getBoundingClientRect().bottom;

    let foundFirstClear = false;
    let lastGridItemTop = Infinity;
    let currentRowGridItems = [];
    let tallestRowGridItemHeight = -Infinity;

    $gridItems.css({
      clear: '',
      height: '',
    });

    for (const gridItem of $gridItems) {
      const $gridItem = $(gridItem);

      const gridItemRect = gridItem.getBoundingClientRect();
      const gridItemPercentageExceeding = gridItemRect.bottom < headerBottom
        ? 0
        : (gridItemRect.bottom - headerBottom) / gridItemRect.height;

      if (lastGridItemTop != Infinity && gridItemRect.top != lastGridItemTop) {
        currentRowGridItems.forEach(($el) => $el.css('height', tallestRowGridItemHeight));
        tallestRowGridItemHeight = -Infinity;
        currentRowGridItems = [];
      }

      tallestRowGridItemHeight = Math.max(tallestRowGridItemHeight, gridItemRect.height);
      currentRowGridItems.push($gridItem);

      if (!foundFirstClear && (gridItemPercentageExceeding > 0.60 || gridItemRect.top > headerBottom)) {
        $(currentRowGridItems[0]).css('clear', 'left');
        foundFirstClear = true;
      }

      lastGridItemTop = gridItem.getBoundingClientRect().top;
    }
  }

  _setSortByQueryParameters() {
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        // Reset the page number when we apply (i.e. don't add it to params)
        if (aKeyValue.length > 1 && aKeyValue[0] != 'page') {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        } else if (aKeyValue[0] === 'page') {
          this.currentPage = parseInt(aKeyValue[1]);
        }
      }
    }
  }

  _updateSortByButtons() {
    this.$sortByOptions
      .filter(`[value="${ this.data.sort_by }"]`)
      .prop('checked', true)
      .parent()
      .addClass('collection-sortby-option-selected');
  }

  _applySortByAndRefine() {
    const isVendor = Shopify.queryParams.q;
    let url = `${this.data.shop_url}/collections/${this.data.collection_handle}/${this.selectedCollectionTag}?${$.param(Shopify.queryParams)}`;

    if (isVendor) {
      url = `${this.data.shop_url}/collections/all/${this.selectedCollectionTag}?${$.param(Shopify.queryParams)}`;
    }

    window.location = url;
  }

  _onFilterChange(value) {
    this.selectedCollectionTag = value;

    this._applySortByAndRefine();
  }

  _onSortByChange(value) {
    Shopify.queryParams.sort_by = value;

    this._applySortByAndRefine();
  }

  _infiniteScrollHandler() {
    // Use handler so _infiniteScroll isn't called with event as argument
    this._infiniteScroll();
  }

  _infiniteScroll(autoScrollCount = 0) {
    if (this.fullCollectionLoaded || autoScrollCount > 2) {
      return;
    }
    const currentPage = `page=${this.currentPage}`;
    this.currentPage++;

    const nextPage = `page=${this.currentPage}`;
    let url = `${window.location.pathname}${window.location.search}`;

    if (window.location.search.indexOf('page') > -1) {
      url = url.replace(currentPage, nextPage);
    } else if (window.location.search.indexOf('?') > -1) {
      url = `${url}&${nextPage}`;
    } else {
      url = `${url}?${nextPage}`;
    }

    this.showMoreButton.classList.add('loading');
    this.showMoreButton.innerHTML = this.showMoreButton.dataset.infiniteScrollLoading;

    $.ajax({
      type: 'GET',
      url,
      success: (data) => {
        const $products = $(data).find('[data-collection-grid-item]');
        for (let i = 0; i < $products.length; i++) {
          // Grid items are what are ultimately appended to the DOM
          const $productGridItem = $products.eq(i);

          // Our JS requires only the article portion of products.
          // Promotion blocks don't have article tags, and should
          // no be added to productItems, but should still be added to DOM
          const $product = $productGridItem.find('article');
          if ($product.length) {
            this.productItems.push(
              new ProductItem($product, this.section.postMessage),
            );
          }

          if (CurrencyConverter.isInitialised) {
            $productGridItem.find('.money').each((index, money) => CurrencyConverter.update(money));
          }

          // Add grid item, either a new product or a promotion block
          $('[data-collection-grid]').append($productGridItem);
          rimg.watch($productGridItem[0]);
        }
        if (this.productItems.length === this.data.total_products) {
          // we've loaded the full collection
          this.fullCollectionLoaded = true;
          this.showMoreButton.style.display = 'none';
        }
        this.showMoreButton.classList.remove('loading');
        this.showMoreButton.innerHTML = this.showMoreButton.dataset.infiniteScrollShowMore;

        // If target is still in viewport, we want to load more items.
        // But let's keep track of how many times we've done this, and
        // take a bit of time to let IntersectionObserver catch up.
        setTimeout(() => {
          if (this.scrollTargetVisible) {
            this._infiniteScroll(autoScrollCount + 1);
          }
        }, 200);
      },
      dataType: 'html',
    });
  }

  onSectionUnload() {
    this._unbindEvents();
    this.menu.unload();

    for (const productItem of this.productItems) {
      productItem.unload();
    }

    if (this.selectFilter && this.selectSortBy) {
      this.selectFilter.unload();
      this.selectSortBy.unload();
    }
  }
}
